import { useMemo } from 'react'
import { makeColor } from 'helpers/_colorMaker'
import { ButtonTag } from 'components/common'

const Tags = ({ tags }) => {
    const storeTags = useMemo(() => {
        return tags?.map((i) => (
            <ButtonTag
                bgColor={makeColor()}
                parentClass={'smallTag'}
                cssClass={'p uppercase'}
                key={i.id}
                content={i.name}
            />
        ))
    }, [tags])

    return (
        <div className='tags flexBoxWrap'>
            {storeTags}
        </div>
    )
}

export default Tags